import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/vehicle-operations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/vehicle-operations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/vehicle-operations/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/vehicle-operations/${data.operation_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/vehicle-operations/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getEmployee = (Options = {}) => {
  return httpClient
    .get('/api/vehicle-operations/employee-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getZone = (Options = {}) => {
  return httpClient
    .get('/api/vehicle-operations/zone-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getVehicle = (Options = {}) => {
  return httpClient
    .get('/api/vehicle-operations/vehicle-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getEmployee,
  getZone,
  getVehicle
}
